import React from "react";
import {
    XLazyColumn,
    XLazyDataTable, XSearchBrowseProps
} from "@michalrakus/x-react-web-lib/XLazyDataTable";
import {ObecForm} from "./ObecForm";

export const ObecBrowse = (props: XSearchBrowseProps) => {

    return (
        <div>
            <XLazyDataTable entity="Obec" label="Obce/mestá" rows={30}
                            sortField="id desc"
                            editForm={<ObecForm/>} removeRow={true}
                            searchBrowseParams={props.searchBrowseParams}>
                <XLazyColumn field="id" header="ID" width="5rem"/>
                <XLazyColumn field="nazov" header="Názov" width="15rem"/>
                <XLazyColumn field="okres.nazov" header="Okres" width="15rem"/>
                <XLazyColumn field="okres.kraj.nazov" header="Kraj" width="15rem"/>
                <XLazyColumn field="oficialnyZaznam" header="Oficiálny záznam"/>
            </XLazyDataTable>
        </div>
    );
}
